import {MainMenu} from "modules/MainMenu";

export default MainMenu;
